export const SEARCH_HOO = 'SEARCH_HOO';
export const SET_SEARCH_HOO = 'SET_SEARCH_HOO';
export const SEARCH_HOO_SUCCESS = 'SEARCH_HOO_SUCCESS';
export const SEARCH_HOO_FAILED = 'SEARCH_HOO_FAILED';

export const FETCH_REQUESTORS = 'FETCH_REQUESTORS';
export const FETCH_REQUESTORS_SUCCESS = 'FETCH_REQUESTORS_SUCCESS';
export const FETCH_REQUESTORS_FAILURE = 'FETCH_REQUESTORS_FAILURE';

export const FETCH_LOCATIONS_FOR_REQUESTOR = 'FETCH_LOCATIONS_FOR_REQUESTOR';
export const FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS = 'FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS';
export const FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE = 'FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE';

export const DELETE_HOO_REQUEST = 'DELETE_HOO_REQUEST';
export const DELETE_HOO_REQUEST_SUCCESS = 'DELETE_HOO_REQUEST_SUCCESS';
export const DELETE_HOO_REQUEST_FAILURE = 'DELETE_HOO_REQUEST_FAILURE';
export const SAVE_HOO_REQUEST = 'SAVE_HOO_REQUEST';
export const SAVE_HOO_REQUEST_SUCCESS = 'SAVE_HOO_REQUEST_SUCCESS';
export const SAVE_HOO_REQUEST_FAILED = 'SAVE_HOO_REQUEST_FAILED';

export const ACCEPT_HOO_REQUEST = 'ACCEPT_HOO_REQUEST';
export const ACCEPT_HOO_REQUEST_SUCCESS = 'ACCEPT_HOO_REQUEST_SUCCESS';
export const ACCEPT_HOO_REQUEST_FAILURE = 'ACCEPT_HOO_REQUEST_FAILURE';

export const REJECT_HOO_REQUEST = 'REJECT_HOO_REQUEST';
export const REJECT_HOO_REQUEST_SUCCESS = 'REJECT_HOO_REQUEST_SUCCESS';
export const REJECT_HOO_REQUEST_FAILURE = 'REJECT_HOO_REQUEST_FAILURE';

export const setSearchHoo = (payload: any) => ({
  type: SET_SEARCH_HOO,
  payload,
});

export const searchHoo = (payload) => ({
  type: SEARCH_HOO,
  payload,
});

export const searchHooSuccess = (payload) => ({
  type: SEARCH_HOO_SUCCESS,
  payload,
});

export const searchHooFailed = (payload) => ({
  type: SEARCH_HOO_FAILED,
  payload,
});

export const fetchRequestors = (positions: string) => ({
  type: FETCH_REQUESTORS,
  payload: { positions },
});

export const fetchRequestorsSuccess = (requestors: any[], allData: any[]) => ({
  type: FETCH_REQUESTORS_SUCCESS,
  payload: { requestors, allData },
});

export const fetchRequestorsFailure = (error: any) => ({
  type: FETCH_REQUESTORS_FAILURE,
  payload: error,
});

export const fetchLocationsForRequestor = (contactSid: number, allData: any[]) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR,
  payload: { contactSid, allData },
});

export const fetchLocationsForRequestorSuccess = (locations: any[]) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR_SUCCESS,
  payload: locations,
});

export const fetchLocationsForRequestorFailure = (error: any) => ({
  type: FETCH_LOCATIONS_FOR_REQUESTOR_FAILURE,
  payload: error,
});

export const deleteHooAccommodation = (payload: any) => ({
  type: DELETE_HOO_REQUEST,
  payload,
});

export const deleteHooAccommodationSuccess = (payload: any) => ({
  type: DELETE_HOO_REQUEST_SUCCESS,
  payload,
});

export const deleteHooAccommodationFailure = (payload: any) => ({
  type: DELETE_HOO_REQUEST_FAILURE,
  payload,
});

export const acceptHooAccommodation = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST,
  payload,
});

export const acceptHooAccommodationSuccess = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST_SUCCESS,
  payload,
});

export const acceptHooAccommodationFailure = (payload: any) => ({
  type: ACCEPT_HOO_REQUEST_FAILURE,
  payload,
});

export const rejectHooAccommodation = (payload: any) => ({
  type: REJECT_HOO_REQUEST,
  payload,
});

export const rejectHooAccommodationSuccess = (payload: any) => ({
  type: REJECT_HOO_REQUEST_SUCCESS,
  payload,
});

export const rejectHooAccommodationFailure = (payload: any) => ({
  type: REJECT_HOO_REQUEST_FAILURE,
  payload,
});

export const SaveHooRequestSuccess = (payload: any) => ({
  type: SAVE_HOO_REQUEST_SUCCESS,
  payload,
});

export const SaveHooRequestFailed = (payload: any) => ({
  type: SAVE_HOO_REQUEST_FAILED,
  payload,
});

export const SaveHooAccommodation = (payload: any) => ({
  type: SAVE_HOO_REQUEST,
  payload,
});
